module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-creative-intro-card1.2@2x.e8c5401c.jpg";